import React from 'react';
import { Box, Typography } from '@mui/material';
import { SpeedometerChart } from './components'; // Adjust the import path as needed

// Sample data - single value between 0 and 1
const sampleValue = 0.74;

interface StrategySpeedometerChartProps {
    title?: string;
    value?: number;
}

const StrategySpeedometerChart: React.FC<StrategySpeedometerChartProps> = ({
    title = "Proprietary Newgate Altcoin Indicator",
    value = sampleValue,
}) => {
    return (
        <Box mt={2} textAlign="center">
            <Typography variant="body1" gutterBottom>
                {title}
            </Typography>
            <Box
                sx={{
                    height: 250,
                    overflow: 'hidden'
                }}
            >
                <SpeedometerChart value={value} />
            </Box>
        </Box>
    );
};

export default StrategySpeedometerChart;
